
<div class="modal-header py-2" *ngIf="title">
  <h4 class="modal-title pull-left">{{ title }}</h4>        
</div>
<div class="modal-body" *ngIf="description">
  <p class="lead m-0">    
    <img src="/assets/img/pacman.svg" alt="Loading pacman" width="60">
    {{ description }}
  </p> 
</div><!-- /.modal-body -->      
